class RegularUtils {
    // 中英文 数字 长度<=16
    static ce_16(str) {
        var reg = /^([\u4E00-\u9FA5A-Za-z0-9]{0,16})$/gim;
        return reg.test(str);
    }
    // 中英文 数字 长度<=32
    static ce_32(str) {
        var reg = /^([\u4E00-\u9FA5A-Za-z0-9]{0,32})$/gim;
        return reg.test(str);
    }
    // 中英文 数字 长度<=200
    static ce_200(str) {
        var reg = /^([\u4E00-\u9FA5A-Za-z0-9]{0,200})$/gim;
        return reg.test(str);
    }
    // 手机
    static is_mobile(str) {
        var reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        return reg.test(str);
    }
    static checkTel(str) {
        if (!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(str)) {
            return false;
        }
        return true;
    }
    // 邮箱
    static checkEmail(str) {
        if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str)) {
            return false;
        }
        return true;
    }
}
export default RegularUtils;